import {useContext, useEffect, useState} from "react";
import BannerFampeMobile from "../../assets/images/banner-fampe-mobile.jpg";
import BannerFampeDesktop from "../../assets/images/banner-fampe-desktop.jpg";
import Breadcrumb from "../../components/breadcrumb";
import {BaSeGrid, BaSeGridItem} from "@base/react";
import Fampe from "./fampe";
import {eventTag, getCurrentCNPJ} from "../../services/utils";
import {AppContext} from "../../context/app";
import ApiFampe from "../../services/fampe";
import FampeModal from "./components/fampe-modal";
import "./index.scss";

const breadcrumb = [
  { label: "Página inicial", href: "/planejadora" },
  { label: "Simulação de Garantias" },
];

const event = {
  name: "guarantees",
  category: "garantias",
  action: "click",
};
const api = ApiFampe()

const Guarantees = ({ account }) => {
  const { companies } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const startSimulate = () => {
    setShowModal(true);
    eventTag(event?.name, event?.category, event?.action, "Simular agora");
    trackMiddleware()
  };
  const closeModal = () => {
    setShowModal(false);
    eventTag(event?.name, event?.category, event?.action, "Fechar simulação");
  };

  const trackMiddleware = async () => {
    try {
      await api.getCallMiddleware()
    } catch (e) {
      console.warn(e)
    }
  }

  return (
    <div className="page-guarantees">
      <div className="wrapper-breadcrumb">
        <Breadcrumb items={breadcrumb} />
      </div>
      <div className="title-section">
        <h2>Simulação de Garantias</h2>
      </div>
      <div className="banner">
        <picture>
          <source media="(min-width: 768px)" srcSet={BannerFampeDesktop} />
          <img src={BannerFampeMobile} alt="Fampe" loading="lazy" />
        </picture>
      </div>
      <div className="wrapper-container">
        <div className="box-content relative-box">
          <BaSeGrid>
            <BaSeGridItem
              tablet={{
                size: 6,
                startAt: undefined,
              }}
            >
              <div className="box-content">
                <div className="text-desktop">
                  <h5>
                    Conheça o FAMPE – o Fundo de Aval às Micro e Pequenas
                    Empresas do Sebrae.
                  </h5>
                  <p>
                    Ele foi criado para ajudar você a completar o valor exigido
                    pelo banco como garantia para o financiamento pretendido.
                  </p>
                </div>
                <div className="text-mobile">
                  <h5>
                    Precisa de empréstimo, mas está com dificuldade por conta da
                    garantia?
                  </h5>
                  <p>
                    Conheça o FAMPE – o Fundo de Aval às Micro e Pequenas
                    Empresas do Sebrae.
                  </p>
                  <p>
                    Ele foi criado para ajudar você a completar o valor exigido
                    pelo banco como garantia para o financiamento pretendido.
                  </p>
                </div>

                <h5>Como funciona o FAMPE?</h5>
                <p>
                  O FAMPE reduz em <strong>até 80%</strong> a necessidade de
                  garantias próprias exigidas pela Instituição Financeira,
                  facilitando o acesso ao crédito para o seu negócio.
                </p>
                <p className="mb-0">
                  <strong>
                    Limites de Garantia do FAMPE por Porte da Empresa:
                  </strong>
                </p>
                <ul>
                  <li>
                    <strong>MEI</strong> – Teto de até{" "}
                    <strong>R$ 100.000,00</strong>
                  </li>
                  <li>
                    <strong>ME</strong> – Teto de até{" "}
                    <strong>R$ 400.000,00</strong>
                  </li>
                  <li>
                    <strong>EPP</strong> – Teto de até{" "}
                    <strong>R$ 700.000,00</strong>
                  </li>
                </ul>
              </div>
            </BaSeGridItem>

            <BaSeGridItem
              tablet={{
                size: 6,
                startAt: undefined,
              }}
            >
              <div className="box-content">
                <h5>Por que utilizar o FAMPE?</h5>
                <p>
                  Seja qual for o seu motivo, o FAMPE quer apoiar você,
                  empreendedor, a manter e fortalecer o seu negócio, mesmo em
                  tempos de crise.
                </p>

                <h5>Quer saber mais?</h5>
                <p>
                  Consulte os detalhes sobre o FAMPE, verifique os{" "}
                  <strong>limites de garantia</strong> para sua empresa e
                  confira as <strong>instituições parceiras</strong> no{" "}
                  <a
                    href="https://sebrae.com.br/sites/PortalSebrae/fampe"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() =>
                      eventTag(
                        "click-button",
                        event?.category,
                        event?.action,
                        "Portal Sebrae"
                      )
                    }
                  >
                    <strong>Portal Sebrae</strong>
                  </a>
                  .
                </p>

                <button
                  type="button"
                  onClick={() => startSimulate()}
                  className="btn-green tablet"
                >
                  Simular agora
                </button>
              </div>
            </BaSeGridItem>
          </BaSeGrid>
        </div>

        <button
          type="button"
          onClick={() => startSimulate()}
          className="btn-green mobile"
        >
          Simular agora
        </button>
      </div>

      <FampeModal
        callBackClose={closeModal}
        show={showModal}
        title={isMobile ? "Simulação de Garantia FAMPE" : null}
      >
        <div className="content-modal">
          <Fampe
            company={getCurrentCNPJ(companies)}
            event={event}
            account={account}
          />
        </div>
      </FampeModal>
    </div>
  );
};

export default Guarantees;
